export default __webpack_public_path__ + "static/media/audio-1.851556f5.wav";